import { render, staticRenderFns } from "./ProfilesPackagingTable.vue?vue&type=template&id=71c7c124&scoped=true"
import script from "./ProfilesPackagingTable.vue?vue&type=script&lang=js"
export * from "./ProfilesPackagingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c7c124",
  null
  
)

export default component.exports